/**************
 Mobile Nav
 ***************/

// find the announcement bar that's currently visible
const announcement = Array.from(document.querySelectorAll('[id*="shopify-section-theme-announcement"]')).find(el => el.offsetHeight > 0);

const header = document.querySelector('#headerV2');
const slider = document.querySelector('#sliderV2');

function updateMobileSliderPosition() {
    // calculate current scroll position
    const scrollPosition = window.scrollY;

    // calculate height of the announcement bar
    const announcementHeight = (announcement ? announcement.offsetHeight : 0) + (document.querySelector(".countdown-timer-block")?.offsetHeight ?? 0);

    // calculate height of the header
    const headerHeight = header.offsetHeight;

    // calculate total offset top
    // we need to subtract the lesser of the announcement height or the scroll position since the announcement bar is static and the header is sticky
    let totalOffsetTop = announcementHeight + headerHeight - Math.min(announcementHeight, scrollPosition);

    // header might have been dynamically created from 'header-override-v2' section, include with the offset top
    if (!announcement && document.querySelector('.announcementOverride')) {
        totalOffsetTop += document.querySelector('.announcementOverride').offsetHeight;
    }

    // set the slider top position
    slider.style.top = `${totalOffsetTop - 1}px`;

    // set the slider height
    slider.style.height = `${document.documentElement.clientHeight - totalOffsetTop}px`;
}

// initial position
updateMobileSliderPosition();

// change as sticky header activates
window.addEventListener('scroll', updateMobileSliderPosition);
window.addEventListener('resize', updateMobileSliderPosition);

//open menu event
document.querySelector("#headerV2Menu")?.addEventListener("click", function () {
    updateMobileSliderPosition();
    slider.showModal();
    document.querySelector("body").classList.add("noScroll");
    header.querySelector('#headerV2Exit').classList.add("active");
})

// toggle menu open/close
header.querySelector('#headerV2Exit')?.addEventListener('click', function () {
    slider.close();
})

// close nav when clicking backdrop event listener
document.querySelector("#sliderV2").addEventListener("click", function (event) {
    if (event.target === this) {
        slider.close();
    }
});

// event listener for escape key
document.querySelector("#sliderV2").addEventListener("close", function (event) {
    document.querySelector("body").classList.remove("noScroll");
    header.querySelector('#headerV2Exit').classList.remove("active");
});

// register dialog
dialogPolyfill.registerDialog(slider);